<!-- Button -->
<button
    mat-icon-button
    [matTooltip]="tooltip || ('Toggle Fullscreen' | transloco)"
    (click)="toggleFullscreen()">
    <ng-container [ngTemplateOutlet]="iconTpl || defaultIconTpl"></ng-container>
</button>

<!-- Default icon -->
<ng-template #defaultIconTpl>
    <mat-icon [svgIcon]="svgIcon"></mat-icon>
</ng-template>
